import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GarantieDetail } from "src/app/parametrage/core/model/garanties/GarantieDetail";
import { GarantieService } from "src/app/parametrage/core/service/garantie.service";
import { ItemDetailComponent } from "./item-detail/item-detail.component";
import { AddGarantieDetailComponent } from "./add-garantie-detail/add-garantie-detail.component";
import { AddDocumentGarantieComponent } from "./add-document-garantie/add-document-garantie.component";
import { NgbdModalConfirm } from "src/app/core/services/utils/modal-confirm";
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from "rxjs/operators";
import { Subject } from "rxjs";
import { EditGarantieDetailComponent } from "./edit-garantie-detail/edit-garantie-detail.component";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { GarantieDocument } from "src/app/parametrage/core/model/garanties/GarantieDocument";

@Component({
  selector: "app-garantie-list",
  templateUrl: "./garantie-list.component.html",
  styleUrls: ["./garantie-list.component.scss"],
})
export class GarantieListComponent implements OnInit {
  @Input() requestId: number;
  request: Request;
  garanties: GarantieDetail[];
  documentsClients: SubItem[] = [];
  documents: GarantieDocument[] = [];
  isRequiredDocExist: boolean = false;

  constructor(
    private modalService: NgbModal,
    private _garantieService: GarantieService,
    private spinner: NgxSpinnerService,
    private _gestionFichierService: GestionFichierService
  ) {}

  ngOnInit() {
    this.getGarantiesByRequestId(this.requestId);

    this.getDocumentGaranties(this.requestId);
    this.getEmptyDocumentsByRequest();
  }

  getGarantiesByRequestId(requestId) {
    this._garantieService
      .getGarantiesByRequestId(requestId)
      .subscribe((data) => {
        this.garanties = data;
      });
  }

  getDocumentGaranties(requestId) {
    this._gestionFichierService
      .getDocumentGaranties(requestId)
      .subscribe((data) => {
        this.documentsClients = data;
      });
  }

  getEmptyDocumentsByRequest() {
    this._garantieService
      .getEmptyDocumentsByRequest(this.requestId)
      .subscribe((data) => {
        this.documents = data;
        if (this.documents && this.documents.length > 0) {
          const requiredDocs = this.documents.filter((doc) => doc.obligatoire);
          if (requiredDocs && requiredDocs.length > 0) {
            this.isRequiredDocExist = true;
          } else {
            this.isRequiredDocExist = false;
          }
        } else {
          this.isRequiredDocExist = false;
        }
      });
  }

  showGarantie(row) {
    const modalRef = this.modalService.open(ItemDetailComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      windowClass: "garantie-detail-modal",
    });
    modalRef.componentInstance.garantie = row;
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then(
      (result) => {
        // on close
        this.getGarantiesByRequestId(this.requestId);
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  deleteGarantie(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelleNature;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer cette garantie";
    modalConfirmRef.componentInstance.description =
      '<span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        this.spinner.show();
        this._garantieService
          .deleteGarantieDetail(row.id)
          .pipe(
            finalize(() => {
              this.spinner.hide();
            })
          )
          .subscribe((data) => {
            this.getGarantiesByRequestId(this.requestId);
            this.getDocumentGaranties(this.requestId);
            this.getEmptyDocumentsByRequest();
          });
      },
      (reason) => {
        //on dismiss
      }
    );
  }

  addGarantieDetail() {
    const modalRef = this.modalService.open(AddGarantieDetailComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      windowClass: "garantie-detail-modal",
    });
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.result.then(
      (result) => {
        // on close
        this.getGarantiesByRequestId(this.requestId);
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  editGarantieDetail(row: GarantieDetail) {
    const modalRef = this.modalService.open(EditGarantieDetailComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      windowClass: "garantie-detail-modal",
    });
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.garantie = row;
    modalRef.result.then(
      (result) => {
        // on close
        this.getGarantiesByRequestId(this.requestId);
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  addDocumentsGarantie(row: GarantieDetail) {
    const modalRef = this.modalService.open(AddDocumentGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "document-detail-modal",
    });
    modalRef.componentInstance.garantie = row;
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
